(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/product-selection.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/product-selection.js');
"use strict";


const {
  useContext,
  useCallback
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useParams
} = ReactRouterDOM;
const {
  resolveProductId
} = svs.utils.products;
const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  getGame
} = svs.components.marketplaceData.selectors.games;
const {
  selectProduct
} = svs.components.marketplaceData.createGame.actions;
const {
  getProductItems
} = svs.components.marketplaceData.createGame.helpers;
const {
  MarketplaceBrand,
  MarketplaceBrandContext
} = svs.components.marketplace.marketplaceBrand;
const {
  getRacingDisplayName
} = svs.utils.racing;
const {
  productIds
} = svs.utils.products;
const HAS_OPEN_PRODUCT_SELECT_ON_LOAD = true;
const ProductSelection = _ref => {
  let {
    allDraws
  } = _ref;
  const dispatch = useDispatch();
  const {
    activatedDrawId,
    groupId
  } = useParams();
  const {
    getBrandedDisplayName
  } = useContext(MarketplaceBrandContext);
  const {
    availableProducts,
    selectedProduct
  } = useSelector(state => state.CreateGame || {});
  const game = useSelector(state => activatedDrawId && getGame(state, {
    activatedDrawId,
    groupId
  }));
  const onSelectProduct = useCallback(productName => {
    const productItems = getProductItems(availableProducts, allDraws);
    const productIsDisabled = productItems.some(_ref2 => {
      let {
        item,
        isDisabled
      } = _ref2;
      return productName === item && isDisabled;
    });
    if (!productIsDisabled) {
      dispatch(selectProduct(productName));
    }
  }, [allDraws, availableProducts, dispatch]);
  if (activatedDrawId) {
    if (!(game !== null && game !== void 0 && game.productId)) {
      return null;
    }
    return React.createElement("div", {
      className: "control-group",
      "data-testid": "product-selection-show"
    }, React.createElement(MarketplaceBrand, {
      productId: game.productId,
      size: 100,
      square: true
    }), React.createElement("div", {
      className: "f-uppercase"
    }, game.productId === productIds.RACING ? getRacingDisplayName(game.productId) : getBrandedDisplayName(game.productId)));
  }
  const productItems = getProductItems(availableProducts, allDraws);
  const selectedProductIndex = productItems.findIndex(_ref3 => {
    let {
      item,
      isDisabled
    } = _ref3;
    return selectedProduct === item || selectedProduct === '' && !isDisabled;
  });
  return React.createElement("div", {
    className: "control-group",
    "data-testid": "product-selection-choose"
  }, React.createElement("div", {
    className: "h4 margin-bottom-1"
  }, "V\xE4lj spelomg\xE5ng"), React.createElement(DropdownSelectItem, {
    className: "margin-bottom-1 select-product-list",
    isOpen: HAS_OPEN_PRODUCT_SELECT_ON_LOAD,
    onSelect: onSelectProduct,
    v2: true
  }, productItems.map((productItem, index) => {
    const {
      item: productName,
      disabledReason,
      isDisabled
    } = productItem;
    const productId = resolveProductId(productName);
    return React.createElement(DropdownItem, {
      disabled: isDisabled,
      key: "".concat(productName, "_").concat(productId),
      name: productName,
      selected: index === selectedProductIndex
    }, React.createElement(MarketplaceBrand, {
      productId: productId,
      size: 100,
      square: true
    }), React.createElement(DropdownLabel, null, React.createElement("div", {
      className: "f-uppercase qa-product-selection-item-name"
    }, productId === productIds.RACING ? getRacingDisplayName(productId) : getBrandedDisplayName(productId))), Boolean(isDisabled) && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "qa-product-selection-disabled-reason"
    }, disabledReason)));
  })));
};
ProductSelection.defaultProps = {
  allDraws: {}
};
setGlobal('svs.components.marketplace.createGame.ProductSelection', ProductSelection);

 })(window);